import { jsx as _jsx } from "react/jsx-runtime";
const IMAGE_WIDTHS = [
    320,
    480,
    768,
    960,
    1200,
    1920
];
export const isSvgImage = (filename)=>filename.endsWith('.svg');
export const getSupportedImageWidths = (imageUrl)=>{
    const [originalWidth] = getImageDimensions(imageUrl) ?? [
        IMAGE_WIDTHS[IMAGE_WIDTHS.length - 1]
    ]; // Fallback to largest width if dimensions can't be determined
    return IMAGE_WIDTHS.filter((width)=>width <= originalWidth);
};
export const getImageDimensions = (filename)=>/\/(\d+)x(\d+)\//g.exec(filename)?.slice(1, 3).map(Number);
export const buildImageUrl = (imageUrl, width, format)=>{
    const baseUrl = `${imageUrl}/m/${width}x0`;
    if (format === 'avif') {
        return `${baseUrl}/filters:format(avif):quality(65)`;
    }
    return baseUrl;
};
export const buildImageSrcSet = (imageUrl, format)=>{
    const widths = getSupportedImageWidths(imageUrl);
    return widths.map((width)=>`${buildImageUrl(imageUrl, width, format)} ${width}w`).join(', ');
};
export const createAvifSourceElement = (imageUrl, sizes)=>{
    return /*#__PURE__*/ _jsx("source", {
        srcSet: buildImageSrcSet(imageUrl, 'avif'),
        type: 'image/avif',
        sizes: sizes
    });
};

//# sourceMappingURL=Picture.helpers.js.map